import React from 'react';
import styled from 'styled-components';

import type { ConsumerUser } from 'src/components/embedded-account/account.types';
import { TabbedOrderListController } from 'src/components/embedded-account/content/order-list/order-list-controller-tabbed';
import { BaseButton } from 'src/components/kiosk-pro/kiosk-pro-layout/consumer-info/consumer-info.styles';
import { ModalContainer } from 'shared/modals';

export function KioskOrderHistoryModal({
  isOpen,
  onClose,
  user,
}: {
  isOpen: boolean;
  onClose: () => void;
  user: ConsumerUser;
}): JSX.Element {
  return (
    <OrderHistoryModalContainer
      isOpen={isOpen}
      onRequestClose={onClose}
      width='900px'
      padding='32px'
      borderRadius='20px'
      ariaHideApp={false}
      contentLabel='Order history'
      data-testid='kiosk-pro-order-history-modal'
    >
      <Header>
        <h2>Order history</h2>
        <CloseButton onClick={onClose} aria-label='Close order history'>
          Close
        </CloseButton>
      </Header>
      <HistoryContent>
        <TabbedOrderListController user={user} />
      </HistoryContent>
    </OrderHistoryModalContainer>
  );
}

const OrderHistoryModalContainer = styled(ModalContainer)`
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-height: 88vh;
  overflow: hidden;
`;

const Header = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  margin-bottom: 24px;

  h2 {
    font-size: 32px;
    font-weight: 700;
  }
`;

const CloseButton = styled(BaseButton)`
  width: auto;
  min-width: 144px;
  padding: 16px 24px;
  font-size: 20px;
`;

const HistoryContent = styled.div`
  max-height: calc(88vh - 140px);
  overflow-y: auto;
  padding: 0 8px 24px;

  button,
  a {
    min-height: 48px;
  }
`;
